import { CheckoutType, TBuy } from "../app/types/checkoutType";
import { ProductProps, WBToken } from "../app/types/types";

export const getBuy = (user: WBToken, product: ProductProps): TBuy => {
  const retBuy = {
    buy: {
      buyCredit51c3: false,
      buyCredit100: false,
    },
    credit51c3: user.credit51c3,
    credit100: user.credit100,
    creditExtra51c3: user.credit100 - user.credit51c3,
    fringebenefit: product.fringebenefit,
    fascia: product.fascia,
  };

  if (retBuy.fringebenefit === 1) {
    if (retBuy.fascia <= retBuy.credit51c3) {
      retBuy.buy.buyCredit51c3 = true;
    }
  } else {
    if (retBuy.fascia <= retBuy.credit100) {
      retBuy.buy.buyCredit100 = true;
    }
    // ******** old condition
    // if (retBuy.fascia <= retBuy.credit51c3) {
    //   retBuy.buy.buyCredit51c3 = true;
    // } else if (retBuy.fascia <= retBuy.creditExtra51c3) {
    //   retBuy.buy.buyCredit100 = true;
    // }
  }

  return retBuy;
};

// FIXME: Parallel function in API order. Same as in api/src/utils/creditUtils.ts
export const updateCheckoutCredit = (
  user: WBToken,
  checkout: CheckoutType
): WBToken => {
  let credit100: number = user.credit100;
  let credit51c3: number = user.credit51c3;

  if (checkout.prodotto) {
    const prezzo = checkout.prodotto.fascia;
    
    if (checkout.prodotto.fringebenefit === 1) {
      // Prodotto fringebenefit: può essere acquistato solo con credit51c3
      if (prezzo <= credit51c3) {
        credit51c3 -= prezzo;
      }
    } else {
      // Prodotto normale: può essere acquistato con credit100 O credit51c3
      // Priorità: prima credit100, poi credit51c3 se necessario
      if (prezzo <= credit100) {
        // Acquista con credit100
        credit100 -= prezzo;
      } else if (prezzo <= credit51c3) {
        // Acquista con credit51c3
        credit51c3 -= prezzo;
      }
    }
  }

  // Validazione finale: assicura che i crediti non diventino negativi
  if (credit100 < 0) credit100 = 0;
  if (credit51c3 < 0) credit51c3 = 0;

  const newUser = { ...user, credit100, credit51c3 };

  return newUser;
};
